import { Button, InputAdornment, Box, Tooltip, CircularProgress } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import VerifyEmailModel from '../../../verifyEmailModel/verifyEmailModel';
import { motion } from 'framer-motion';
import EmailIcon from '@mui/icons-material/Email';

const EmailVerification = ({ 
  isVerified,
  onVerifyClick,
  openModal,
  setOpenModal,
  loading = false
}) => {
  return (
    <InputAdornment position="end">
      {isVerified ? (
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 200 }}
        >
          <Tooltip title="Email verified">
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                background: 'rgba(0, 255, 136, 0.1)',
                padding: '4px 8px',
                borderRadius: '8px',
                border: '1px solid rgba(0, 255, 136, 0.3)',
              }}
            >
              <CheckCircleIcon 
                sx={{ 
                  color: '#00ff88', 
                  fontSize: '1.2rem',
                  filter: 'drop-shadow(0 0 8px rgba(0, 255, 136, 0.3))',
                }} 
              />
              <motion.span
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.2 }}
                style={{ 
                  fontSize: '0.75rem', 
                  fontWeight: 600,
                  color: '#00ff88',
                }}
              >
                Verified
              </motion.span>
            </Box>
          </Tooltip>
        </motion.div>
      ) : (
        <>
          <Button
            onClick={onVerifyClick}
            disabled={loading}
            startIcon={!loading ? <EmailIcon /> : <CircularProgress size={16} />}
            variant="outlined"
            size="small"
            sx={{
              color: '#00ff88',
              borderColor: 'rgba(0, 255, 136, 0.3)',
              background: 'rgba(0, 255, 136, 0.05)',
              fontWeight: 600,
              minWidth: '120px',
              '&:hover': {
                background: 'rgba(0, 255, 136, 0.1)',
                borderColor: 'rgba(0, 255, 136, 0.5)',
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 12px rgba(0, 255, 136, 0.2)',
              },
              '&:disabled': {
                background: 'rgba(255, 255, 255, 0.05)',
                borderColor: 'rgba(255, 255, 255, 0.1)',
                color: 'rgba(255, 255, 255, 0.3)',
              },
              transition: 'all 0.3s ease',
              textTransform: 'none',
              fontSize: '0.75rem',
              padding: '6px 12px',
            }}
          >
            {loading ? 'Sending...' : 'Verify Email'}
          </Button>
          <VerifyEmailModel 
            open={openModal} 
            setOpen={setOpenModal} 
          />
        </>
      )}
    </InputAdornment>
  );
};

export default EmailVerification;